import styled from 'styled-components';
import { useEffect } from 'react';

import { Checkbox } from 'shared/components/Checkbox';
import { useLocation } from 'shared/hooks/useLocation';
import { useCountriesQuery } from 'store/api/countries';
import { t } from 'localization/utils/t';

const TP = 'account.components.NewsLetterSignUpCheckbox';

export const NewsletterSignUpCheckbox = ({
  isNewsletterSignUpChecked,
  handleNewsletterSignUpChange,
  darkTheme = false,
}) => {
  const { selectedCountryCode } = useLocation();
  const { data } = useCountriesQuery();
  const countries = data?.countries || [];

  useEffect(() => {
    const countryData = countries?.find((country) => country.isoCode === selectedCountryCode);
    if (countryData && countryData?.allowPrecheckEmailSignup) {
      handleNewsletterSignUpChange(true);
    }
  }, [selectedCountryCode, countries]);

  return (
    <NewsletterSignUpCheckbox.Checkbox
      checked={isNewsletterSignUpChecked}
      id="newsletter-sign-up"
      data-qa="newsletter_sign_up"
      label={t(
        `${TP}.newsletterSignUp`,
        'I would like to receive GOAT emails with exclusive promos, popular releases and more',
      )}
      name="newsletterSignUp"
      onChange={handleNewsletterSignUpChange}
      darkTheme={darkTheme}
    />
  );
};

NewsletterSignUpCheckbox.Checkbox = styled(Checkbox)`
  margin-top: -12px;
`;
